<template>
  <div id="defaultConfiguration">
    <Tabs>

      <TabSection :title="$t('settings.configure_features')"
        v-if="(branchModule.onlineOrdering || branchModule.catering) && !!companyId">
        <TipBox info>
          <span v-html="$t('tips.features')"></span>
        </TipBox>
        <div class="columns">
          <div class="column">
            <div class="feature" :class="{ locked: !branchModule.onlineOrdering }">
              <span class="feature-name">{{ $t("deliveryMethod.takeout") }}</span>
              <select v-model="config.takeout.activated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group" :class="{ locked: !branchModule.onlineOrdering }"
              v-if="config.takeout.activated && $store.getters.loggedUserHasSuperAdmin">
              <input id="orderMethodTakeoutHidden" type="checkbox" v-model="config.takeout.hidden">
              <label for="orderMethodTakeoutHidden">
                {{ $t("settings.hidden") }}
                <tag>superadmin</tag>
              </label>
            </div>
            <div class="feature" :class="{ locked: !branchModule.onlineOrdering }">
              <span class="feature-name">{{ $t("deliveryMethod.delivery") }}</span>
              <select v-model="config.delivery.activated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group third-party" :class="{ locked: !branchModule.onlineOrdering }"
              v-if="!config.delivery.activated && !!companyId">
              <router-link :to="$router.buildContext('/third-party-delivery')">
                <span>{{ $t('settings.go_to_third_party_delivery') }}</span>
                <svgicon src="icon/arrow-right.svg" :height="14" :width="14"></svgicon>
              </router-link>
            </div>
            <div class="group" :class="{ locked: !branchModule.onlineOrdering }"
              v-if="config.delivery.activated && $store.getters.loggedUserHasSuperAdmin">
              <input id="orderMethodDeliveryHidden" type="checkbox" v-model="config.delivery.hidden">
              <label for="orderMethodDeliveryHidden">
                {{ $t("settings.hidden") }}
                <tag>superadmin</tag>
              </label>
            </div>
            <div class="feature" :class="{ locked: !branchModule.catering }">
              <span class="feature-name">{{ $t("deliveryMethod.catering") }}</span>
              <select v-model="config.catering.activated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group" :class="{ locked: !branchModule.catering }"
              v-if="config.catering.activated && $store.getters.loggedUserHasSuperAdmin">
              <input id="orderMethodCateringHidden" type="checkbox" v-model="config.catering.hidden">
              <label for="orderMethodCateringHidden">
                {{ $t("settings.hidden") }}
                <tag>superadmin</tag>
              </label>
            </div>
          </div>
          <div class="column">
            <div class="feature" :class="{ locked: !branchModule.onSiteOrdering }">
              <span class="feature-name">{{ $t("deliveryMethod.in_place") }}</span>
              <select v-model="config.inPlace.activated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group" :class="{ locked: !branchModule.onSiteOrdering }"
              v-if="config.inPlace.activated && $store.getters.loggedUserHasSuperAdmin">
              <input id="orderMethodinPlaceHidden" type="checkbox" v-model="config.inPlace.hidden">
              <label for="orderMethodinPlaceHidden">
                {{ $t("settings.hidden") }}
                <tag>superadmin</tag>
              </label>
            </div>
            <div class="feature" :class="{ locked: !branchModule.onSiteOrdering }">
              <span class="feature-name">{{ $t("deliveryMethod.hotel") }}</span>
              <select v-model="config.hotel.activated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group" :class="{ locked: !branchModule.onSiteOrdering }"
              v-if="config.hotel.activated && $store.getters.loggedUserHasSuperAdmin">
              <input id="orderMethodHotelHidden" type="checkbox" v-model="config.hotel.hidden">
              <label for="orderMethodCateringHidden">
                {{ $t("settings.hidden") }}
                <tag>superadmin</tag>
              </label>
            </div>
          </div>
        </div>
        <template v-if="!branchModule.catering || !branchModule.onlineOrdering || !branchModule.onSiteOrdering">
          <br><br>
          <TipBox warning no-border>
            <span v-html="$t('tips.module_locked')"></span>
          </TipBox>
        </template>
      </TabSection>

      <TabSection :title="$t('settings.configure_geocoding')"
        v-if="!!!companyId && config.default && config.default.geocode && branch">
        <div class="columns">
          <div class="column">
            <div class="group" style="display:none !important;" v-show="usesGoogleApi">
              <label>{{ $t("settings.google_api_key") }}</label>
              <input type="text" v-model="config.default.geocode.googleApiKey">
            </div>
            <div class="group" v-show="false && usesHereApi">
              <label>{{ $t("settings.here_api_key") }}</label>
              <input type="text" v-model="config.default.geocode.hereApiKey">
            </div>
            <div class="subtitle">{{ $t('settings.map_display') }}</div>
            <div class="group">
              <input id="enableMapOnCompanyDetailsChk" type="checkbox"
                v-model="config.default.geocode.enableMapOnCompanyDetails">
              <label for="enableMapOnCompanyDetailsChk">{{ $t("settings.map_company_details") }}</label>
            </div>
            <div class="group">
              <input id="enableMapOnCompanySelectionChk" type="checkbox"
                v-model="config.default.geocode.enableMapOnCompanySelection">
              <label for="enableMapOnCompanySelectionChk">{{ $t("settings.map_company_selection") }}</label>
            </div>
            <br>
            <div class="subtitle">{{ $t('settings.autocomplete_address') }}</div>
            <div class="group">
              <input id="autocompleteOnOrderTypeChk" type="checkbox" v-model="branch.autocompleteOnOrderType">
              <label for="autocompleteOnOrderTypeChk">{{ $t("settings.autocomplete_on_ordertype") }}</label>
            </div>
            <div class="group">
              <input id="autocompleteOnPaymentChk" type="checkbox" v-model="branch.autocompleteOnPayment">
              <label for="autocompleteOnPaymentChk">{{ $t("settings.autocomplete_on_payment") }}</label>
            </div>
          </div>
          <div class="column">
            <div class="subtitle">{{ $t('settings.advanced_configurations') }}</div>
            <div class="group">
              <input id="detailedAddressFieldsOnCompanySelectionChk" type="checkbox"
                v-model="config.default.geocode.detailedAddressFieldsOnCompanySelection">
              <label for="detailedAddressFieldsOnCompanySelectionChk">{{ $t("settings.detailed_fields_company_selection")
              }}</label>
            </div>
            <div class="group">
              <input id="companySearch_chk" type="checkbox" v-model="config.default.geocode.companySearchActivated">
              <label for="companySearch_chk">{{ $t("settings.company_search") }}</label>
            </div>
            <div class="subtitle">{{ $t('settings.geocode_service_choice') }}</div>
            <div class="group">
              <label>{{ $t("settings.geolocation_service_enabled") }}</label>
              <select v-model="config.default.geocode.geocodeService">
                <option value="google">Google</option>
                <option value="here">Here API</option>
              </select>
            </div>
            <div class="group">
              <label>{{ $t("settings.maps_service_enabled") }}</label>
              <select v-model="config.default.geocode.mapsService">
                <option value="google">Google</option>
                <option value="here">Here API</option>
              </select>
            </div>
            <div class="group">
              <label>{{ $t("settings.autocomplete") }}</label>
              <select v-model="config.default.geocode.autocompleteService">
                <option value="google">Google</option>
                <option value="here">Here API</option>
              </select>
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('settings.configure_emergency_settings')" v-if="!!companyId">
        <TipBox warning>
          <span v-html="$t('tips.emergency_close.description')"></span>
        </TipBox>
        <div>
          <div class="feature" v-if="('emergencyCloseManually' in rootFields)">
            <span class="feature-name">{{ $t('settings.emergency_close') }}</span>
            <select v-model="rootFields.emergencyCloseManually">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
          <div class="feature" v-if="('emergencyCloseManuallyMessage' in rootFields)">
            <span class="feature-name">{{ $t('settings.emergency_close_message') }}</span>
            <LocalizedInput textarea :translate="rootFields.emergencyCloseManuallyMessage" />
          </div>
          <div v-if="$store.getters.loggedUserHasSuperAdmin">
            <div class="feature" v-if="('notifyIfPosIsNotReachable' in rootFields)">
              <span class="feature-name">{{ $t('settings.notify_if_pos_is_not_reachable') }}</span>
              <select v-model="rootFields.notifyIfPosIsNotReachable">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
          </div>
          <br>
          <TipBox danger no-border>
            <span v-html="$t('tips.no_pos.description')"></span>
            <br>
            <b v-html="$t('tips.no_pos.procedures')"></b>
          </TipBox>
          <div class="feature" v-if="('emergencyCloseExternalOffline' in rootFields)">
            <span class="feature-name">{{ $t('settings.emergency_close_pos_offline') }}</span>
            <select v-model="rootFields.emergencyCloseExternalOffline">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
        </div>
      </TabSection>

      <!--<Panel :title="$t('message')" v-if="config.default" v-show="!!companyId" collapsible collapsed>
        <div class="group">
          <LocalizedInput textarea :title="$t('settings.service_message')" :translate="config.default.onEnterMessage.message" />
        </div>
        <div class="group">
          <input id="chkPopupDefault" type="checkbox" v-model="config.default.onEnterMessage.type" true-value="popup" :false-value="null">
          <label for="chkPopupDefault">{{$t('settings.open_in_window')}}</label>
        </div>
      </Panel>-->

      <TabSection :title="$t('settings.tip_configuration')" v-if="!!company">
        <TipBox no-border info>
          <span v-html="$t('tips.doordash.tips')"></span>
          <ul>
            <li v-html="$t('tips.doordash.tips_li1')"></li>
            <li v-html="$t('tips.doordash.tips_li2')"></li>
          </ul>
        </TipBox>
        <template v-if="isDoorDashShipperActivated">
          <br>
          <div class="subtitle">{{ $t('settings.tip_option_not_delivery') }}</div>
        </template>
        <div class="columns">
          <div class="column">
            <div class="feature">
              <div class="feature-name">{{ $t("settings.tip_options") }}</div>
              <div class="tip" v-for="(tip, tipIndex) of tipOptions" :key="tipIndex">
                <input class="tip-input" type="text" v-model="tipOptions[tipIndex]"
                  :class="{ invalid: parentValidate.error('config.default.general.tipOptions') }">
                <svgicon src="icon/close.svg" :height="12" :width="12" @click="removeTip(tipIndex)"></svgicon>
              </div>
              <div class="add-tip" @click="addTip">
                <svgicon src="icon/add.svg" :height="12" :width="12"></svgicon>
              </div>
            </div>
            <div class="feature" v-if="config.default.general.tipOptions.length > 0">
              <div class="feature-name">{{ $t("settings.default_tip_value") }}</div>
              <Tooltip :text="$t('settings.default_tip_value')"></Tooltip>
              <select v-model="config.default.defaultTipAmount">
                <option :value="null">{{ $t('choose') }}...</option>
                <option :value="tip" v-for="tip of tipOptions">{{ tip }} %</option>
              </select>
            </div>
            <div class="feature">
              <span class="feature-name" v-html="$t('settings.hide_none_tip_option')"></span>
              <select v-model="config.default.hideNoneTipOption">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="feature">
              <span class="feature-name" v-html="$t('settings.hide_fixed_tip_option')"></span>
              <select v-model="config.default.hideFixedAmountTipOption">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('settings.about_config')" v-if="!companyId">
        <TipBox info>
          <span v-html="$t('settings.about_info')"></span>
        </TipBox>
        <div class="columns">
          <div class="column">
            <div class="group">
              <LocalizedInput :title="$t('settings.about_title')" :translate="config.about.title" />
            </div>
            <br>
            <div class="group">
              <LocalizedInput textarea :title="$t('settings.about_description')" :translate="config.about.description" />
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('settings.configure_other')">
        <div class="columns">
          <div class="column">
            <div class="subtitle">{{ $t('settings.anonymous_login') }}</div>
            <TipBox info no-border>
              <span v-html="$t('tips.guest')"></span>
            </TipBox>
            <TipBox danger no-border>
              <span v-html="$t('tips.guest_danger')"></span>
            </TipBox>
            <div class="feature">
              <span class="feature-name">{{ $t('settings.anonymous_login') }}</span>
              <select v-model="config.default.general.anonymousLogin">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
          </div>
          <div class="column">
            <div class="subtitle">{{ $t('settings.commentBoxActivated') }}</div>
            <TipBox info no-border>
              <span v-html="$t('tips.comments')"></span>
            </TipBox>
            <div class="feature">
              <span class="feature-name">{{ $t('settings.commentBoxActivated') }}</span>
              <select v-model="config.default.general.commentBoxActivated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('settings.superadmin_config')" v-if="$store.getters.loggedUserHasSuperAdmin"
        tag="superadmin">
        <div class="description">{{ $t('settings.manage_superadmin') }}</div>
        <br>
        <Panel :title="$t('settings.customer_notifications')" collapsible collapsed v-if="!!company">
          <TipBox warning no-border v-if="!isSMSactivated">
            <div v-html="$t('tips.sms_feature.disabled')"></div>
          </TipBox>
          <TipBox danger no-border :class="{ locked: !isSMSactivated }">
            <b v-html="$t('tips.sms_feature.fees')"></b>:
            <template v-if="company.country === 'CA'">{{ $tc(0.015, company.currency, 3) }}</template>
            <template v-if="company.country === 'US'">{{ $tc(0.01, company.currency) }}</template>
            <template v-if="company.country === 'GB'">{{ $tc(0.01, company.currency) }}</template>
          </TipBox>
          <div class="feature" :class="{ locked: !isSMSactivated }">
            <span class="feature-name">{{ $t('settings.activate_customer_notifications') }}</span>
            <select v-model="config.default.notifications.activateCustomerNotificationsBySms">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
        </Panel>

        <Panel :title="$t('settings.hold_and_fire')" v-if="!!companyId" collapsible collapsed>
          <div class="feature">
            <div class="feature-name">{{ $t('settings.activate_hold_and_fire') }}</div>
            <select v-model="rootFields.holdAndFire">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
          <div class="feature" v-show="rootFields.holdAndFire">
            <div class="feature-name sub-feature">{{ $t('settings.hold_and_fire_minutes') }}</div>
            <input type="number" v-model="rootFields.holdAndFireOptions.minutes">
          </div>
          <div class="feature" v-show="rootFields.holdAndFire">
            <div class="feature-name sub-feature">{{ $t('settings.hold_and_fire_schedule') }}</div>
            <div>
              <template v-for="(scheduleEntry, i) of rootFields.holdAndFireOptions.schedule">
                <button class="btn btn-secondary" @click="removeHoldAndFireTime(i)" style="margin-left: 5px">X</button>
                <select v-model="scheduleEntry.time" style="margin-left: 5px">
                  <option :value="formatHour(n - 1)" v-for="n in 96" :key="`time_${i}_${n}`">{{ formatHour(n - 1) }}
                  </option>
                </select>
              </template>
              <button class="btn btn-primary" @click="addHoldAndFireTime" style="margin-left: 5px">+</button>
            </div>
          </div>
          <div class="feature" v-show="rootFields.holdAndFire">
            <span class="feature-name sub-feature">{{ $t('settings.bypass_pos_mode_emails') }}</span>
            <VueSelect multiple v-model="rootFields.bypassPosOptions.emails" taggable>
              <span slot="no-options">{{ $t("settings.email_tip") }}</span>
            </VueSelect>
          </div>
          <!--
          <div class="feature" v-show="rootFields.holdAndFire">
            <span class="feature-name indented">{{$t('settings.bypass_pos_mode_sms')}}</span>
            <VueSelect multiple v-model="rootFields.bypassPosOptions.sms" taggable>
              <span slot="no-options">{{$t("settings.sms_tip")}}</span>
            </VueSelect>
          </div>
          -->
        </Panel>

        <Panel :title="$t('settings.configure_stock_management')" collapsed collapsible>
          <div class="feature">
            <span class="feature-name">{{ $t('settings.activate_stock_management') }}</span>
            <select v-model="rootFields.stockActivated">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
        </Panel>

        <Panel :title="$t('settings.configure_constraints_verification')" collapsed collapsible>
          <TipBox no-border danger>
            <span v-html="$t('tips.orders_outside_of_range')"></span>
          </TipBox>
          <template v-for="c of onFlushConstraints">
            <input :id="`chk_${c}`" type="checkbox" :value="c" v-model="config.default.onFlush.checks">
            <label :for="`chk_${c}`">{{ $t(`on_flush_checks.${c}`) }}</label>
          </template>
        </Panel>

        <Panel :title="$t('settings.pos_safe_mode_configuration')" v-if="posActivated" collapsible collapsed>
          <div class="feature">
            <span class="feature-name">{{ $t('settings.bypass_pos_mode') }}</span>
            <select v-model="rootFields.bypassPosMode">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
          <div class="feature" v-if="rootFields.bypassPosMode">
            <span class="feature-name">{{ $t('settings.bypass_pos_mode_emails') }}</span>
            <VueSelect multiple v-model="rootFields.bypassPosOptions.emails" taggable>
              <span slot="no-options">{{ $t("settings.email_tip") }}</span>
            </VueSelect>
          </div>
          <!--
          <div class="feature" v-if="rootFields.bypassPosMode">
            <span class="feature-name indented">{{$t('settings.bypass_pos_mode_sms')}}</span>
            <VueSelect multiple v-model="rootFields.bypassPosOptions.sms" taggable>
              <span slot="no-options">{{$t("settings.sms_tip")}}</span>
            </VueSelect>
          </div>
          -->
          <div class="feature" v-if="rootFields.bypassPosMode">
            <span class="feature-name">{{ $t('settings.notify_customer') }}</span>
            <select v-model="rootFields.bypassPosOptions.notifyCustomer">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
          <div class="danger-text">{{ $t('settings.bypass_pos_mode_warning') }}</div>
        </Panel>

        <Panel :title="$t('settings.payment_only_mode')" collapsible collapsed>
          <div>{{ $t('settings.payment_only_description') }}</div>
          <div class="feature">
            <span class="feature-name">{{ $t('settings.activate_payment_only') }}</span>
            <select v-model="config.default.activatePaymentOnly">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
        </Panel>

        <Panel :title="$t('settings.advanced_configurations')" collapsible collapsed>
          <div class="columns">
            <div class="column">
              <div class="feature" v-if="!!!companyId && branch && branch.tutorial">
                <span class="feature-name">{{ $t('settings.tutorial_activated') }}</span>
                <select v-model="branch.tutorial.activated">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="feature" v-if="!!!companyId && branch">
                <span class="feature-name">{{ $t('settings.email_validation_required') }}</span>
                <select v-model="branch.emailValidationRequired">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="feature" v-if="!!!companyId && branch && branch.homePage &&
                branch.loyaltyActivated && branch.loyaltyConfig && branch.loyaltyConfig.type === 'ishopfood'">
                <span class="feature-name">{{ $t('settings.home_page_activated') }}</span>
                <select v-model="branch.homePage.activated">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="feature" v-if="companyId && company && company.menuDisplay">
                <span class="feature-name">
                  {{ $t('settings.menu_display_activated') }}
                </span>
                <select v-model="company.menuDisplay.activated" @change="$emit('changeMenuDisplay', $event)">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="feature" v-if="companyId && company && company.menuDisplay.activated">
                <span class="feature-name sub-feature">{{ $t('settings.menu_display_prices') }}</span>
                <select v-model="company.menuDisplay.fromOrderMethod" @change="$emit('changeFromOrderMethod', $event)">
                  <option :value="key" v-for="(method, key) in config" v-if="method.activated">{{ $t('deliveryMethod.' +
                    key) }}</option>
                </select>
              </div>
              <div class="feature" v-if="companyId">
                <div class="feature-name">{{ $t("settings.disable_phone_requirement") }}</div>
                <select v-model="config.phoneNotRequired">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="feature" v-if="!companyId">
                <div class="feature-name">{{ $t("settings.activate_favorite_company") }}</div>
                <select v-model="config.enableFavoriteCompany">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="feature" v-if="!companyId">
                <div class="feature-name">{{ $t("settings.activate_reorder_from_history") }}</div>
                <select v-model="config.default.reorderFromHistoryActivated">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="feature" v-if="!companyId">
                <div class="feature-name">{{ $t("settings.hide_cookies_banner") }}</div>
                <select v-model="config.hideCookiesPolicyBanner">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
            </div>
          </div>
        </Panel>
      </TabSection>

      <TabSection class="tutorial" :title="$t('tutorial.configuration')"
        v-if="branch && branch.tutorial && branch.tutorial.activated">
        <div class="top">
          <div class="empty">{{ $t('tutorial.empty') }}</div>
          <button class="add btn btn-primary" @click="addTutorialPage"
            :class="{ disabled: branch.tutorial.pages.length >= 5 }">
            <svgicon src="/icon/add.svg" :height="16" :width="16"></svgicon>
          </button>
        </div>
        <div class="pages">
          <div class="page" v-for="(page, pageIndex) of branch.tutorial.pages">
            <div class="title">
              <div class="name">{{ $t('tutorial.page') }} #{{ pageIndex + 1 }}</div>
              <button class="remove btn btn-primary" @click="removeTutorialPage(pageIndex)">
                <svgicon src="/icon/close.svg" :height="16" :width="16"></svgicon>
              </button>
            </div>
            <div class="columns">
              <div class="column">
                <div class="group">
                  <LocalizedInput :title="$t('tutorial.title')" :translate="page.title" />
                </div>
                <div class="group">
                  <LocalizedInput textarea :title="$t('tutorial.description')" :translate="page.description" />
                </div>
              </div>
              <div class="column">
                <ImageUpload :identifier="'tutorialImagePage' + pageIndex" :object="page.image" :maxSizeInMb="0.8"
                  @changed="changePageImage(pageIndex, $event)"></ImageUpload>
              </div>
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection
        v-if="branch && branch.homePage && branch.homePage.activated && branch.loyaltyActivated && branch.loyaltyConfig && branch.loyaltyConfig.type === 'ishopfood'"
        :title="$t('settings.home_page_configuration')">
        <div class="columns">
          <div class="column">
            <div class="group">
              <LocalizedInput :title="$t('home_page.title')" :translate="branch.homePage.title" />
            </div>
            <div class="group">
              <LocalizedInput textarea :title="$t('home_page.subtitle')" :translate="branch.homePage.subtitle" />
            </div>
          </div>
        </div>
      </TabSection>

    </Tabs>

    <div class="footer-actions" v-if="$store.getters.loggedUserHasModifyPermission">
      <button class="btn btn-primary" @click="$emit('save')">{{ $t("save") }}</button>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import VueSelect from 'vue-select';
  import Cascader from "@/resources/cascader";
  import ImageUpload from "@/components/tools/ImageUpload.vue";
  import DayTimeRange from '@/components/tools/DayTimeRange.vue';
  import Tooltip from "@/components/tools/Tooltip";

  export default {
    name: 'default',

    props: {
      config: Object,
      rootFields: Object,
      permissions: Object,
      parentValidate: Object,
      branchModule: Object,
      posActivated: Boolean,
      branch: Object
    },

    components: { LocalizedInput, VueSelect, DayTimeRange, Tooltip, ImageUpload },

    async mounted() {
      this.cascader = new Cascader(this.config, this.parentConfig);

      this.setTips();
    },

    computed: {
      company() {
        return this.$store.state.contextCompany;
      },
      isSMSactivated() {
        return this.company && this.company.smsActivated;
      },
      isDoorDashShipperActivated() {
        return this.company && this.company.shipper === "doordash";
      },
      usesGoogleApi() {
        return this.config.default.geocode.geocodeService === "google"
          || this.config.default.geocode.mapsService === "google"
          || this.config.default.geocode.autocompleteService === "google";
      },
      usesHereApi() {
        return this.config.default.geocode.geocodeService === "here"
          || this.config.default.geocode.mapsService === "here"
          || this.config.default.geocode.autocompleteService === "here";
      },
      companyId() {
        return this.$route.query.company;
      },
    },

    watch: {
      tipOptions: function () {
        this.config.default.general.tipOptions = this.tipOptions.join(",");

        let defaultAmount = this.config.default.defaultTipAmount;
        if (this.tipOptions.indexOf(defaultAmount) === -1) {
          this.config.default.defaultTipAmount = null;
        }
      }
    },

    data() {
      return {
        cascader: null,
        tipOptions: [],
        onFlushConstraints: ['company_open']
      }
    },

    methods: {
      setTips() {
        let tips = this.config.default.general.tipOptions;
        if (tips) {
          this.tipOptions = tips.split(",").map(amount => parseInt(amount));
        } else {
          this.tipOptions = [10, 12, 15, 20];
        }
      },
      removeTip(index) {
        this.tipOptions.splice(index, 1);
      },
      addTip() {
        this.tipOptions.push("");
      },
      addTutorialPage() {
        if (this.branch.tutorial.pages.length >= 5) {
          return;
        }
        this.$emit("addTutorialPage");
      },
      removeTutorialPage(pageIndex) {
        this.$emit("removeTutorialPage", pageIndex);
      },
      changePageImage(pageIndex, image) {
        this.$emit("changeTutorialImage", {
          pageIndex: pageIndex,
          image: image
        });
      },
      addHoldAndFireTime() {
        if (!this.rootFields.holdAndFireOptions.schedule) {
          Vue.set(this.rootFields.holdAndFireOptions, 'schedule', []);
        }
        this.rootFields.holdAndFireOptions.schedule.push({ time: '00:00' });
      },
      removeHoldAndFireTime(index) {
        this.rootFields.holdAndFireOptions.schedule.splice(index, 1)
      },
      formatHour(n) {
        let hour = Math.floor(n / 4);
        let minute = n % 4 * 15;
        return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      }
    }
  };
</script>

<style lang="scss" scoped>
  #defaultConfiguration {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .feature {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    select {
      width: 170px;
      flex-shrink: 0;
    }

    textarea {
      width: 60%;
    }
  }

  .feature-name {
    flex-grow: 1;
    font-weight: 500;

    &.sub-feature {
      font-weight: normal;
      padding-left: 30px;
      position: relative;

      &::before {
        content: "►";
        padding-right: 10px;
        color: var(--primary-color);
      }
    }
  }

  .tooltip {
    margin-right: 10px;
    height: 20px;
  }

  .danger-text {
    color: indianred;
  }

  .indented {
    margin-left: 20px;
  }

  .feature .v-select {
    width: 300px;
  }

  .tutorial {

    .top,
    .title {
      display: flex;
      align-items: center;
      fill: white;
      justify-content: space-between;
      padding-bottom: 15px;
    }

    .title {
      font-weight: bold;
      font-size: 18px;
    }

    .page {
      border-top: 1px solid #ccc;
      padding-top: 15px;
    }

    .empty {
      color: #888;
      font-size: 14px;
    }
  }

  .third-party {
    width: 100%;

    a {
      color: var(--primary-color);
      fill: var(--primary-color);
      justify-content: flex-end;
      text-decoration: none;
      font-size: 14px;
      display: flex;

      .svgicon {
        margin-top: 3px;
      }
    }
  }

  .tip-input {
    max-width: 70px;
    padding: 10px 20px 10px 5px;
    margin-right: 5px;
  }

  .tip {
    position: relative;

    .svgicon {
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      fill: #ccc;
    }
  }

  .add-tip {
    padding: 5px;
    cursor: pointer;
    fill: var(--primary-color);
  }
</style>
